module.exports = __webpack_public_path__ + "img/zdyx4.c0686c3f.png";